import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i0 from '@angular/core';
import { Directive, Input, NgModule } from '@angular/core';
import { take } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

class XpoAutofocusDirective {
    constructor(el, zone) {
        this.el = el;
        this.zone = zone;
        this.applyValue = true;
        this.initialized = false;
    }
    get apply() {
        return this.applyValue;
    }
    set apply(value) {
        this.applyValue = coerceBooleanProperty(value);
        if (this.initialized) {
            this.focusElement();
        }
    }
    ngAfterContentInit() {
        this.initialized = true;
        if (!this.apply) {
            return;
        }
        this.focusElement();
    }
    focusElement() {
        this.zone.onStable
            .asObservable()
            .pipe(take(1))
            .subscribe(() => {
            this.el.nativeElement.focus();
        });
    }
}
XpoAutofocusDirective.ɵfac = function XpoAutofocusDirective_Factory(t) { return new (t || XpoAutofocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
XpoAutofocusDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoAutofocusDirective, selectors: [["", "xpoAutofocus", ""]], inputs: { apply: ["xpoAutofocus", "apply"] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAutofocusDirective, [{
        type: Directive,
        args: [{
                selector: '[xpoAutofocus]',
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }]; }, { apply: [{
            type: Input,
            args: ['xpoAutofocus']
        }] }); })();

class XpoAutofocusModule {
}
XpoAutofocusModule.ɵfac = function XpoAutofocusModule_Factory(t) { return new (t || XpoAutofocusModule)(); };
XpoAutofocusModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoAutofocusModule });
XpoAutofocusModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAutofocusModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [XpoAutofocusDirective],
                exports: [XpoAutofocusDirective],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoAutofocusModule, { declarations: [XpoAutofocusDirective], imports: [CommonModule], exports: [XpoAutofocusDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoAutofocusDirective, XpoAutofocusModule };
